import { render, staticRenderFns } from "./NewBigMapDrawer.vue?vue&type=template&id=c6561c32&scoped=true"
import script from "./NewBigMapDrawer.vue?vue&type=script&lang=js"
export * from "./NewBigMapDrawer.vue?vue&type=script&lang=js"
import style0 from "./NewBigMapDrawer.vue?vue&type=style&index=0&id=c6561c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6561c32",
  null
  
)

export default component.exports